module.exports = __webpack_public_path__ + "static/media/solarwinds-logo-white.e1ac3d97.svg";